// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "This is a neutral quiz template featuring two types of questions.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Neutral quiz",
  id: "neutral-quiz",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/neutral-quiz/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "NeutralQuizConfigTool" */ "app/components/tools/NeutralQuizConfigTool/NeutralQuizConfigTool"),
    loading: DynamicImportLoader,
    modules: ["NeutralQuizConfigTool"]
  })
};

export default CONFIG;
